import { newToolFilterOAuthMcp } from "../oauth.ts";

export const aieraMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://aiera.com/wp-content/uploads/2026/06/aiera-favicon.png",
  url: "https://mcp-pub.aiera.com/",
  label: "Aiera",
});
